import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

/**
 * Adds working-period-id header to API requests when userEnv is available.
 */
export const workingPeriodInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes(environment.apiUrl) || req.url.includes('config.json')) {
    return next(req);
  }

  try {
    const cached = sessionStorage.getItem('userEnv');
    const userEnv = cached ? JSON.parse(cached) : null;
    const workingPeriod = userEnv?.working_period;

    if (workingPeriod?.id != null) {
      const cloned = req.clone({
        setHeaders: {
          'working-period-id': String(workingPeriod.id),
        },
      });
      return next(cloned);
    }
  } catch {
    // ignore parse errors
  }

  return next(req);
};
